import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  position: relative;
  /* height: calc(100vh - var(--nav-bar-height) - (var(--pd-player-padding) * 2)); */
  height: 100%;
  width: 100%;
  ${(props) =>
    props.$isFullscreen &&
    css`
      height: 100vh;
    `}
`;
export const UnityWrapper = styled.div`
  position: relative;
  overflow: hidden;
  margin: 0 auto;
  background-color: var(--unity-loading-bg-color);
  width: 100%;
  height: 100%;
  canvas {
    width: 100%;
    height: 100%;
  }
  ${(props) =>
    props.isFullscreen &&
    css`
      border-radius: 0;
    `}
`;
export const Message = styled.div`
  padding: 2rem;
  text-align: center;
  line-height: 1.5rem;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  max-width: 90%;
  font-size: 1rem;
  @media only screen and (min-width: 992px) {
    font-size: 1.4rem;
  }
`;

export const CornerUI = styled.div`
  position: absolute;
  top: 1rem;
  right: 4rem;
  z-index: 1;
  display: flex;
  gap: 0.5rem;
`;
